export default __webpack_public_path__ + "static/media/facebookIcon.083c0d2c.svg";